export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

export const isOwned = (featuresOwned: any, id: any) => {
  return featuresOwned?.find((item: any) => item.feature_id?._id === id)
}
